import { render, staticRenderFns } from "./ed-content-section.vue?vue&type=template&id=1b829c4a&scoped=true&"
import script from "./ed-content-section.ts?vue&type=script&lang=ts&"
export * from "./ed-content-section.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-section.scss?vue&type=style&index=0&id=1b829c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b829c4a",
  null
  
)

export default component.exports